<template v-slot="main">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ $t('closed_modal.title') }}</h2>
    </div>

    <div class="modal-body">
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn">
        {{ $t('Ok') }}
      </button>
    </div>
  </div>
</template>

<script>
import BaseModal from '@/layout/modals/BaseModal.vue'

export default {
  extends: BaseModal,
  name: 'CloseRoomModal',
  methods: {
    endRoom () {
      this.$store.dispatch('rooms/sendCloseRoom')
      this.closeModal()
      this.$router.push('/dashboard')
    }
  }
}
</script>
